export const selectSku = (sku) => {
    return {
        type: 'SELECT_SKU',
        payload: {
            sku,
        },
    }
}
